import { createContext, useContext, type ReactNode } from 'react';
import { useCommandPalette } from '../hooks/use-command-palette';

type PaletteContextValue = ReturnType<typeof useCommandPalette>;

const PaletteContext = createContext<PaletteContextValue | null>(null);

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const palette = useCommandPalette();
  return <PaletteContext.Provider value={palette}>{children}</PaletteContext.Provider>;
}

export function usePalette(): PaletteContextValue {
  const ctx = useContext(PaletteContext);
  if (!ctx) throw new Error('usePalette must be inside CommandPaletteProvider');
  return ctx;
}
